import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ThrobberWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
`;

export const PopupDescription = styled.div`
  height: fit-content;
  width: 100%;
  ${FONTS.XS};
  white-space: pre-wrap;
  margin-bottom: 5px;
  color: ${COLORS.darkGrey};
  @media (max-width: 713px) {
    ${FONTS.XXS};
  }
  @media (max-width: 690px) {
    ${FONTS.XS};
  }
  @media (max-width: 350px) {
    ${FONTS.XXS};
  }
`;

export const PopupButton = styled(BaseButton)<{ isPhoneCreatedValue: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(50% - 8px);
  max-width: fit-content;
  margin-bottom: 15px;
  white-space: nowrap;
  padding: 14px 19px;
  max-height: 48px;

  @media (max-width: 1023px) {
    width: ${({ isPhoneCreatedValue }) => isPhoneCreatedValue ? '100%' : 'calc(50% - 8px)'};
  }

  @media (max-width: 767px) {
    width: 100%;
    max-width: initial;
    margin-bottom: 0;
  }
`;

export const ConfirmPopup = styled(DefaultPopup)<{ isShowMobilePlank: boolean }>`
  padding: 40px 60px 24px 60px;
  min-height: initial !important;
  max-width: 847px;
  min-width: 327px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 847px;

  @media (max-height: 767px) {
    margin: ${({ isShowMobilePlank }) => isShowMobilePlank ? '150px 0' : '100px 0'};
  }

  @media (max-width: 1023px) {
    width: 700px;
  }

  @media (max-width: 767px) {
    top: 36px;
    padding: 40px 20px;
    min-height: auto;
    width: 80%;
  }

  @media (max-width: 320px) {
    width: 100%;
    min-width: 320px;
  }
`;

export const ConfirmPopupTitle = styled.div`
  position: relative;
  max-width: 570px;
  ${FONTS.H2};
  color: ${COLORS.black};
  text-overflow: ellipsis;
  z-index: 2;
  width: 100%;
  margin-bottom: 24px;
  &:hover {
    overflow: visible;
    white-space: normal;
  }
  @media (max-width: 767px) {
    ${FONTS.H3};
  }
`;

export const ConfirmPopupDescription = styled(PopupDescription)<{ isYandex?: boolean }>`
  flex-direction: column;
  height: fit-content;
  width: 100%;
  ${FONTS.XS};
  white-space: pre-wrap;
  margin-bottom: 24px;
  color: ${COLORS.darkGrey};

  p {
    ${FONTS.S};

    :first-child {
      margin-bottom: ${({ isYandex }) => isYandex ? '24px' : '0'};
    }

    :last-child {
      margin-top: ${({ isYandex }) => isYandex ? '24px' : '0'};
    }

    @media (max-width: 767px) {
      ${FONTS.XS};
    }
  }

  @media (max-width: 713px) {
    ${FONTS.XXS};
  }
  @media (max-width: 690px) {
    ${FONTS.XS};
  }
  @media (max-width: 350px) {
    ${FONTS.XXS};
  }
`;

export const ConfirmPopupFooter = styled.div<{ isPhoneCreatedValue: boolean }>`
  justify-content: flex-start;
  flex-wrap: nowrap;
  column-gap: 12px;
  width: 100%;

  @media (max-width: 1023px) {
    flex-direction: ${({ isPhoneCreatedValue }) => isPhoneCreatedValue ? 'column' : 'row'};
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }

  > div:nth-child(2) {
    max-width: 221px;

    @media (max-width: 1023px) {
      max-width: ${({ isPhoneCreatedValue }) => isPhoneCreatedValue ? '100%' : '221px'};
    }

    @media (max-width: 864px) {
      max-width: ${({ isPhoneCreatedValue }) => isPhoneCreatedValue ? '100%' : '140px'};
    }

    @media (max-width: 767px) {
      width: 100%;
      max-width: initial;
    }
  }

  div:first-child {
    max-width: 221px;
    margin-bottom: 0;

    @media (max-width: 1023px) {
      max-width: ${({ isPhoneCreatedValue }) => isPhoneCreatedValue ? '100%' : '221px'};
      margin-bottom: ${({ isPhoneCreatedValue }) => isPhoneCreatedValue ? '5px' : '0'};
    }

    @media (max-width: 767px) {
      width: 100%;
      margin-bottom: 5px;
      max-width: initial;
    }
  }
`;

export const ChatLink = styled.span`
  color: ${COLORS.blue};
  transition: .3s;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;
